import { DropdownItem } from '../../models/dropdown-item';
import { PioneerUtils } from '../../utils/pioneer-utils';
import { Chain } from '../../models/chain-brand/chain';
import { Brand } from '../../models/chain-brand/brand';

export class ChainBrandMapper {

    static convertChainsToDropDownItem(chains: Chain[]): DropdownItem[] {
        return chains.map(chain => ChainBrandMapper.convertChainToDropDownItem(chain));
    }

    static convertBrandsToDropDownItem(brands: Brand[]): DropdownItem[] {
        return brands.map(brand => ChainBrandMapper.convertBrandToDropDownItem(brand));
    }

    static convertChainToDropDownItem(chain: Chain): DropdownItem {
        return new DropdownItem(PioneerUtils.safeTrim(chain.chainCode), PioneerUtils.safeTrim(chain.name));
    }

    static convertBrandToDropDownItem(brand: Brand): DropdownItem {
        return new DropdownItem(PioneerUtils.safeTrim(brand.brandCode), PioneerUtils.safeTrim(brand.name));
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain-brand.mapper.ts